export const deletePremade = async (apiCall, premadeId, version) => {
  const request = { premadeId, version };
  const response = await apiCall("/premade/delete", "POST", request, "dev");
  return response && response.success;
};

export const getPremade = async (apiCall, premadeId, version) => {
  return await apiCall(`/premade/get`, "POST", { premadeId, version }, "dev");
};

export const savePremade = async (apiCall, id, script, summary) => {
  const request = { script, summary };
  if (id) {
    request.premadeId = id;
  }
  return await apiCall("/premade/save", "POST", request, "dev");
};

export const publishPremade = async (apiCall, premadeId) => {
  const request = { premadeId };
  const resp = await apiCall("/premade/publish", "POST", request, "dev");
  return resp && resp.success;
};

export const buildPremade = async (apiCall, script) => {
  const request = { script };
  return await apiCall("/premade/build", "POST", request, "dev");
};

export const listPremades = async (apiCall, version) => {
  return await apiCall(`/premade/list`, "POST", { version }, "dev");
};

export const searchPremades = async (apiCall, searchText) => {
  const request = { searchText };
  return await apiCall("/premade/search", "POST", request, "user,dev");
};

export const formatPremade = async (apiCall, script) => {
  const request = { script };
  return await apiCall("/premade/format", "POST", request, "dev");
};

export const reloadPremades = async apiCall => {
  return await apiCall("/premade/reload", "POST", {}, "admin");
};

export const targetPremades = async (apiCall, capabilityIds, functionIds) => {
  const request = {
    capabilityIds: capabilityIds || [],
    functionIds: functionIds || [],
  };
  return await apiCall("/premade/target", "POST", request, "dev");
};

export const listAspects = async apiCall => {
  return await apiCall("/premade/aspect", "POST", {}, "dev");
};
